var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import uriTemplates from 'uri-templates';
import omit from 'lodash.omit';
import PropTypes from 'prop-types';
import { Link as RouterLink, NavLink as RouterNavLink } from 'react-router-dom';
export const Link = (_a) => {
    var { refresh, external, to, activeClassName, innerRef } = _a, props = __rest(_a, ["refresh", "external", "to", "activeClassName", "innerRef"]);
    if (external) {
        return React.createElement("a", Object.assign({ ref: innerRef, href: to, target: "_blank", rel: "noopener noreferrer" }, props));
    }
    if (refresh) {
        return React.createElement("a", Object.assign({ ref: innerRef, href: to }, props));
    }
    if (activeClassName) {
        return React.createElement(RouterNavLink, Object.assign({ to: to }, props, { activeClassName: activeClassName }));
    }
    return React.createElement(RouterLink, Object.assign({ to: to }, props));
};
Link.propTypes = {
    to: PropTypes.string.isRequired,
    refresh: PropTypes.bool,
    external: PropTypes.bool,
    activeClassName: PropTypes.string,
};
Link.defaultProps = {
    refresh: false,
    external: false,
    activeClassName: '',
};
export const ExternalLink = props => React.createElement(Link, Object.assign({ external: true }, props));
export const HyperLink = props => React.createElement(Link, Object.assign({ refresh: true }, props));
export function createLink(urlTemplate, defaults = {}) {
    const template = typeof urlTemplate === 'string' ? uriTemplates(urlTemplate) : urlTemplate;
    if (!template.varNames.length) {
        const to = template.toString();
        const FixedLink = props => React.createElement(Link, Object.assign({ to: to }, defaults, props));
        return FixedLink;
    }
    const TemplateLink = props => {
        const to = template.fill(props);
        const passDownProps = omit(props, template.varNames);
        return React.createElement(Link, Object.assign({ to: to }, defaults, passDownProps));
    };
    return TemplateLink;
}
//# sourceMappingURL=index.js.map